import IconButton from "@mui/material/IconButton";
import { useRouter } from "next/router";

export default function EitaButton() {
    const router = useRouter();

    // if (router.pathname === "/register/new") {
    //     return <></>;
    // }

    return (
        <IconButton
            sx={{
                position: "fixed",
                left: { xs: "15px", sm: "18px" },
                bottom: { xs: "15px", sm: "15px" },
                zIndex: "1000000",
                borderRadius: "9999px",
                width: { xs: "45px", sm: "55px" },
                height: { xs: "45px", sm: "55px" },
                background: "url(/images/eitaa-icon.png) #ef7c02",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "100%",
            }}
            target="_blank"
            component="a"
            href="https://eitaa.com/onlinehawzah"
            size="small"
        />
    );
}
